export enum AuthFlowType {
  CREDENTIALS = 'credentials',
  SITE_CREDENTIALS = 'site-credentials'
}

export interface FlowConfig {
  form: string;
  labels: {
    headerTitle: string;
    headerSubtitle?: string;
    titleAria: string;
    outDatedButton: string;
    inputAria: {
      mobile: string;
      email: string
    }
  }
}

export const FLOW_CONFIGS: Record<AuthFlowType, FlowConfig> = {
  [AuthFlowType.CREDENTIALS]: {
    form: "validate_password__" + AuthFlowType.CREDENTIALS,
    labels: {
      headerTitle: "card_association_otp_options.header_title",
      titleAria: 'card_association_otp_options.header_message',
      headerSubtitle: "card_association_otp_options.header_message",
      outDatedButton: 'card_association_otp_options.information_outdated',
      inputAria: {
        mobile: 'accessibility.card_association_otp_options.input.mobile',
        email: 'accessibility.card_association_otp_options.input.email'
      }
    }
  },
  [AuthFlowType.SITE_CREDENTIALS]: {
    form: "validate_password__" + AuthFlowType.SITE_CREDENTIALS,
    labels: {
      headerTitle: "card_association_otp_options.header_title",
      headerSubtitle: "card_association_otp_options.header_message",
      titleAria: 'card_association_otp_options.header_message',
      outDatedButton: 'card_association_otp_options.information_outdated',
      inputAria: {
        mobile: 'accessibility.card_association_otp_options.input.mobile',
        email: 'accessibility.card_association_otp_options.input.email'
      }
    }
  }
}